export default "__VITE_ASSET__CMRhrvGW__"